import React from "react";
import History from "../../utilities/History";
import { IGradeFormData } from "../../models/grade/GradeFormData";
import { RouteComponentProps } from "react-router";
import { withRouter } from "react-router-dom";
import IColumnHeaderData from "../../models/shared/ColumnHeaderData";
import { IInstrumentViewData } from "../../models/instrument/InstrumentViewData";
import tableFormatter from "../shared/TableFormatter";
import triggerNotifications from "../../utilities/TriggerNotifications";
import instrumentActions from "../../flux/actions/InstrumentActions";
import propertyActions from "../../flux/actions/PropertyActions";
import instrumentSelectedIdStore from "../../flux/stores/instrument/BySelectedIdStore";
import propertySelectedIdStore from "../../flux/stores/property/BySelectedIdStore";
import { CHANGE_EVENT, GRADE_CREATE_URL } from "../../utilities/Constants";
import testplanActions from "../../flux/actions/TestplanActions";
import testplanByIdStore from "../../flux/stores/testplan/ByIdStore";
import { ITestplanViewData } from "../../models/testplan/TestplanViewData";
import { Button, Dialog, Icon } from "@abb/abb-common-ux-react";
import TableComponent from "../shared/TableComponent";
import { IPropertyViewData } from "../../models/property/PropertyViewData";
import * as CONSTANTS from "../../utilities/Constants";
import { Translation } from "react-i18next";
import ITestplanFormData from "../../models/testplan/TestplanFormData";

type PropsType = RouteComponentProps & {
  location: any;
};

interface IState {
  list: any[];
  selected: string[];
  isOk: boolean;
  previousState: IGradeFormData;
  selectedKeyedIn?: any[];
  selectedInstrument?: any[];
}

class AssociateProperty extends React.Component<PropsType, IState> {
  private _mount: boolean;
  private _columns: IColumnHeaderData[];
  private _fetchedTestplan: ITestplanViewData;
  private _fetchedInstruments: IInstrumentViewData[] = [];
  private _fetchedProperties: IPropertyViewData[] = [];

  private _preserveMeasuredProperty: any[] = [];
  private _preserveKeyedInProperty: any[] = [];
  private _preserveCalculatedProperty: any[] = [];
  private _preserveSelectedCalculatedProperty: any[] = [];
  private _preserveSelectedKeyedInProperties: any[] = [];
  constructor(props: PropsType) {
    super(props);

    let previousState
    if (this.props.location?.state?.gradeFormData) {
      previousState = this.props.location?.state?.gradeFormData;
    } else {
      previousState = this.props.location?.state?.testPlanFormData;
    }
    const selectedInstrument = this.props.location.state.selectedInstrument ?
      this.props.location.state.selectedInstrument : []
    const selectedKeyedIn = this.props.location.state.selectedKeyedIn ?
      this.props.location.state.selectedKeyedIn : []
    this.state = {
      list: [],
      previousState,
      isOk: false,
      selected: previousState.properties.map((d: any) => d.propertyId),
      selectedInstrument,
      selectedKeyedIn,
    };

    this._mount = false;
  }

  componentWillUnmount() {
    this._mount = false;
  }

  componentDidMount() {
    this._mount = true;

    this.state.previousState.properties.forEach((item) => {
      // PropertySpecification
      if (item.isMeasured) {
        this._preserveMeasuredProperty.push(item);
      } else if (item.isCalculated) {
        this._preserveCalculatedProperty.push(item);
      } else {
        this._preserveKeyedInProperty.push(item);
      }
    });
    this._preserveSelectedCalculatedProperty = this.state.previousState.selectedCalculatedProperty ? [
      ...this.state.previousState.selectedCalculatedProperty,
    ] : []; // CalculatedPropertyData
    if (this.props.location.state.testPlanFormData) {
      this._preserveSelectedKeyedInProperties = this.state.previousState?.selectedKeyedInProperties ? [
        ...this.state.previousState?.selectedKeyedInProperties,
      ] : []; // KeyedInPropertyData
    }

    if (this.state.selectedInstrument.length !== 0) {
      const propertiesToBeFetched: any[] = [];
      this.state.selectedKeyedIn.forEach((d) => {
        propertiesToBeFetched.push(d.value);
        console.log(propertiesToBeFetched);
      });

      // Fetch Properties for all testplan instruments
      const instrumentsToFetch: string[] = [];
      this.state.selectedInstrument?.forEach((d) => {
        instrumentsToFetch.push(d.value);
        console.log(instrumentsToFetch);
      });
      this.setProperties(instrumentsToFetch, propertiesToBeFetched)
    } else {
      testplanActions
        .getById(this.state.previousState?.testplan?.id)
        .then(() => {
          const propertiesToBeFetched: any[] = [];
          this._fetchedTestplan?.keyedIns?.forEach((d) => {
            propertiesToBeFetched.push(d.id);
            console.log(propertiesToBeFetched);
          });

          // Fetch Properties for all testplan instruments
          const instrumentsToFetch: string[] = [];
          this._fetchedTestplan.instruments.forEach((d) => {
            instrumentsToFetch.push(d.id);
            console.log(instrumentsToFetch);
          });
          this.setProperties(instrumentsToFetch, propertiesToBeFetched)
        })
        .catch((error) => {
          triggerNotifications.errors(error.message, error.data).then();
        });
    }

    testplanByIdStore.on(CHANGE_EVENT, (state) => {
      this._fetchedTestplan = state.testplanData;
    });

    propertySelectedIdStore.on(CHANGE_EVENT, (state) => {
      this._fetchedProperties = state.data.result;
    });

    instrumentSelectedIdStore.on(CHANGE_EVENT, (state) => {
      this._fetchedInstruments = state.instrumentDataList.result;
    });
  }

  private setProperties = (instrumentsToFetch: any, propertiesToBeFetched: any) => {
    instrumentActions
      .getSelected(instrumentsToFetch)
      .then(() => {
        const list = [...this.state.list];
        this._fetchedInstruments.forEach((d) => {
          d.properties.forEach((p) => {
            const pName = p.name + " (" + d.codeId + ")";
            list.push({
              id: p.id,
              name: pName,
              descripton: p.description,
              customId: p.customId,
              type: p.type.name,
              typeId: p.type.id,
              unit: p.unit,
              decimal: p.decimals,
              isMeasured: true,
              instrumentId: d.id,
            });
          });
        });

        propertyActions
          .getSelected(propertiesToBeFetched)
          .then(() => {
            this._fetchedProperties.forEach((p) => {
              list.push({
                id: p.id,
                name: p.name,
                descripton: p.description,
                customId: p.customId,
                type: p.type,
                typeId: p.typeId,
                unit: p.unit,
                decimal: p.decimal,
                isMeasured: false,
                instrumentId: "",
              });
            });

            this.state.previousState.properties.forEach((p) => {
              if (p.isCalculated) {
                list.push({
                  id: p.propertyId,
                  name: p.propertyName,
                  descripton: "",
                  customId: p.propertyCustomId,
                  type: "Calculated",
                  typeId: "",
                  unit: "",
                  decimal: "",
                  isMeasured: false,
                  instrumentId: p.instrumentId,
                });
              }
            });

            this.setState({
              list,
            });
          })
          .catch((error) => {
            triggerNotifications.errors(error.message, error.data).then();
          });

        this.setState({
          list,
        });
      })
      .catch((error) => {
        triggerNotifications.errors(error.message, error.data).then();
      });
  }

  private handleOnSelect = (row: any, isSelect: boolean) => {
    if (isSelect) {
      this.setState({
        selected: [...this.state.selected, row.id],
      });
    } else {
      this.setState(() => ({
        selected: this.state.selected.filter((x) => x !== row.id),
      }));
    }
  };

  private handleOnSelectAll = (isSelect: boolean, rows: any) => {
    const ids = rows.map((r: any) => r.id);
    if (isSelect) {
      this.setState(() => ({
        selected: ids,
      }));
    } else {
      this.setState(() => ({
        selected: [],
      }));
    }
  };

  private onAddSelectedClicked = () => {
    const data = this.state.list.filter((x) =>
      this.state.selected.includes(x.id)
    ) as any[];
    const previousState: any = this.state.previousState;
    const propertiesToCarry = previousState.properties.filter((d: any) =>
      data.map((t) => t.id).includes(d.propertyId)
    );
    const newProperties = data.filter(
      (d) => !propertiesToCarry.map((e: any) => e.propertyId).includes(d.id)
    );

    const obj: any = {};

    const previousInstruments =
      this.props.location.state.instrumentDropdownList;
    previousInstruments.forEach((item: any) => {
      obj[item.value] = item;
    });

    previousState.properties = [
      ...propertiesToCarry,
      ...this._preserveKeyedInProperty,
      ...this._preserveCalculatedProperty,
    ];

    previousState.properties = [...propertiesToCarry];

    previousState.allProperties.forEach((items: any) => {
      newProperties.forEach((item) => {
        if (items.propertyId === item.id) {
          previousState.properties.push(items);
        }
      });
    });

    previousState.selectedInstruments = [];
    previousState.properties.forEach((item: any) => {
      if (
        obj[item.instrumentId] &&
        !previousState.selectedInstruments.find(
          (el: any) => el.value === obj[item.instrumentId].value
        )
      ) {
        previousState.selectedInstruments.push({
          label: obj[item.instrumentId].label,
          value: obj[item.instrumentId].value,
        });
      }
    });
    previousState.selectedCalculatedProperty = [
      ...this._preserveSelectedCalculatedProperty,
    ];
    if (this.state.selectedInstrument.length !== 0) {
      previousState.calculatedProperties = [
        ...this._preserveSelectedCalculatedProperty,
      ]
      let keyedInProperties = previousState?.properties?.filter((i: any) => i.isMeasured === false && i.isCalculated === false)
      const keyedInData: any[] = [];
      keyedInProperties.forEach(
        (element: any) => {
          keyedInData.push({
            value: element.propertyId,
            label: element.propertyName,
          });
        }
      );

      let keyedInPartitionData: any[] = [];
      keyedInPartitionData = keyedInData.map((i: any) => {
        let tempVar
        tempVar = previousState.keyedInPartitions.find((x: any) => x.id === i.value)
        return tempVar;
      })

      previousState.selectedKeyedInProperties = [
        ...keyedInData
      ]

      previousState.keyedIns = [
        ...keyedInPartitionData
      ]
      previousState.showformula = true
      History.replace(CONSTANTS.TESTPLAN_CREATE_URL, {
        ...previousState,
      });
    } else {
      let calcProperties = previousState?.properties?.filter((i: any) => i.isMeasured === false && i.isCalculated === true)
      let calc = calcProperties.map((x: any) => {
        let tempCalc
        tempCalc = previousState?.selectedCalculatedProperty.find((i: any) => {
          if (i?.property?.id) {
            return i?.property?.id === x?.propertyId
          }
          if (i.propertyId) {
            return i?.propertyId === x?.propertyId
          } else {
            return i?.value === x?.propertyId
          }
        })
        return tempCalc
      })
      if (previousState.isEditMode) {
        previousState.selectedCalculatedProperty = [
          ...calc,
        ]
      } else {
        previousState.selectedCalculatedProperty = [
          ...calcProperties,
        ]
      }

      History.replace(GRADE_CREATE_URL, {
        ...previousState,
      });
    }
  };

  private performTypeChange = () => {
    this.setState(
      {
        isOk: true,
      },
      () => {
        if (this.state.isOk) {
          if (this.state.selectedInstrument.length !== 0) {
            History.replace(CONSTANTS.TESTPLAN_CREATE_URL, {
              ...this.props.location.state.testPlanFormData,
            });
          } else {
            History.replace(GRADE_CREATE_URL, {
              ...this.props.location.state.gradeFormData,
            });
          }
        }
      }
    );
  };

  private onClickCancel = () => {
    this.setState({
      isOk: true,
    });
  };

  goBack = () => {
    const previousState = this.state.previousState as any;
    if (this.state.selectedInstrument.length !== 0) {
      History.replace(CONSTANTS.TESTPLAN_CREATE_URL, {
        ...this.state.previousState,
      });
    } else {
      History.replace(GRADE_CREATE_URL, {
        ...previousState,
      });
    }
  };
  public render() {
    return (
      <Translation>
        {(t) => (
          <div className="app-container mt-4">
            <div className="container-box rounded-sm rounded-lg submit-header-fixed ml-1 ">
              <div className="row no-padding">
                <div className="col-md-6 col-lg-6 col-sm-6">
                  <div className="viewall-page">
                    <div>
                      <Icon
                        name="abb/caret-left"
                        sizeClass="large"
                        style={{ cursor: "pointer" }}
                        onClick={this.goBack}
                      />
                    </div>
                    <div className="viewall-page-title">
                      <span
                        className="title font-weight-bold mt-2 ml-1"
                        style={{ verticalAlign: "super" }}
                      >
                        {t(CONSTANTS.ALL_PROPERTIES)}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-lg-6 col-sm-6">
                  <span className="float-right">
                    <Button
                      text={t(CONSTANTS.BUTTON_ADD_SELECTED)}
                      id="btnAddSelected"
                      disabled={this.state.selected.length === 0}
                      icon="abb/check-mark"
                      type="primary-blue"
                      onClick={this.onAddSelectedClicked}
                    />
                  </span>
                </div>
              </div>
            </div>
            <TableComponent
              list={this.state.list}
              columns={[
                {
                  dataField: "name",
                  text: t(CONSTANTS.MODULE_PROPERTY),
                  headerStyle: (colum, colIndex) => {
                    return { textAlign: "left" };
                  },
                  style: {
                    fontWeight: "600",
                  },
                },
                {
                  dataField: "",
                  text: "",
                  isDummyField: true,
                  style: { position: "relative" },
                  formatter: tableFormatter.verticalLineSeparator,
                  headerStyle: (colum, colIndex) => {
                    return { width: "1%" };
                  },
                },
                {
                  dataField: "customId",
                  text: t(CONSTANTS.LABLE_ID),
                  headerStyle: (colum, colIndex) => {
                    return { width: "10%", textAlign: "left" };
                  },
                },
                {
                  dataField: "unit",
                  text: t(CONSTANTS.LABEL_UNIT),
                  headerStyle: (colum, colIndex) => {
                    return { width: "10%", textAlign: "left" };
                  },
                },
                {
                  dataField: "descripton",
                  text: t(CONSTANTS.LABEL_DESCRIPTION),
                  headerStyle: (colum, colIndex) => {
                    return { width: "35%", textAlign: "left" };
                  },
                },
                {
                  dataField: "decimal",
                  text: t(CONSTANTS.LABEL_DECIMALS),
                  headerStyle: (colum, colIndex) => {
                    return { width: "10%", textAlign: "left" };
                  },
                },
                {
                  dataField: "type",
                  text: t(CONSTANTS.TYPE),
                  headerStyle: (colum, colIndex) => {
                    return { width: "10%", textAlign: "left" };
                  },
                },
              ]}
              select={true}
              name={t(CONSTANTS.LABEL_PROPERTIES)}
              selected={this.state.selected}
              handleOnSelect={this.handleOnSelect}
              handleOnSelectAll={this.handleOnSelectAll}
            />

            <Dialog
              isOpen={this.state.isOk}
              // tslint:disable-next-line: jsx-no-lambda
              onClose={() => this.setState({ isOk: false })}
              showCloseButton={true}
              closeOnEscape={false}
              closeOnLostFocus={false}
              dimBackground={true}
              standardButtonsOnBottom={[
                {
                  text: t(CONSTANTS.BUTTON_CANCEL),
                  type: "discreet-blue",
                  handler: (dlg) => dlg.close(),
                },
                {
                  text: t(CONSTANTS.BUTTON_OK),
                  type: "primary-blue",
                  handler: this.performTypeChange,
                },
              ]}
            >
              <div>
                <b>{t(CONSTANTS.NOTE)}:</b>{" "}
                {t(
                  CONSTANTS.LOOSE_CURRENT_CHANGE_CHANGE_MESSAGE +
                  " " +
                  t("Associate Property")
                )}
                <br />
                {t(CONSTANTS.SAVE_MESSAGE)}
              </div>
            </Dialog>
          </div>
        )}
      </Translation>
    );
  }
}

export default withRouter(AssociateProperty);
